import { BOLT_IMPORT_ID, MSG_DEPLOY } from '~/lib/constants';
import { chatStore } from '~/lib/stores/chat';
import type { Message } from '~/types/chat';
import { DEPLOYMENT_MARKER, FAILED_DEPLOYMENT_MARKER } from '~/utils/markers';

export function isDeploymentMessage(message?: Message) {
  return message?.type === 'chat' && message.content.includes(DEPLOYMENT_MARKER);
}

export function isFailedDeploymentMessage(message?: Message) {
  return message?.type === 'chat' && message.content.includes(FAILED_DEPLOYMENT_MARKER);
}

export function getLastNonImportMessage(messages: Message[]) {
  return messages.findLast((message) => !isImportMessage(message));
}

export function isImportMessage(message: Message) {
  return message.id === BOLT_IMPORT_ID;
}

export function triggerDeploy() {
  chatStore.events.dispatch('sendChatMessage', { message: MSG_DEPLOY, mode: 'build' });
}
